export default {
	section_banner: {
		title: {
			one: 'One Tether',
			two: 'Earn',
			three: 'Additional',
		},
		main_title: {
			one: 'Reward Points',
		},
		sub_title: {
			one: 'By Using',
			two: 'One Tether',
		},
		paragraph: {
			one: 'Save money by transactions, cashback offers and promotional code and get rewards from the best stores and your favorite brands.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},
	maximize_rewards_sec: {
		label: 'Fastest Payment System',
		title: {
			one: 'Maximize Your',
			two: 'Rewards',
		},
		paragraph: {
			one: 'Combining transactions, cashback suggestions and promotional codes can save you more money. We will help you find and apply promotion codes when you pay. With JPWorldPay, smart shopping is effortless and rewarding. Maximize your savings with every purchase.',
			two: 'Does JPWorldPay card offer a reward? Check out with your purchase and use it to get a reward. Earn points every time you spend and enjoy exclusive benefits.',
		},
		cta_buttons: 'Start Shopping',
	},
	question_sec: {
		label: 'Choose And Trade',
		title: {
			one: 'Your',
			two: 'Ideal',
			three: 'Cryptocurrency',
		},
		paragraph: {
			one: 'We will showcase deals, products and stores you think you will like based on where you shop and buy, and we promise to continue to increase and update your favorite stores.',
		},
		cta_buttons: 'Get Started',
	},
	online_mid: {
		label: 'Online Shopping',
		title: {
			one: 'Online Shopping',
			two: 'With JPWorldPay',
		},
		paragraph:
			'Utilize transaction and cashback offers from millions of global retailers when making payments securely with JPWorldPay. Your information is encrypted and will not be sold or shared without your permission. Enjoy fast, safe, and rewarding payments with every purchase. Join the JPWorldPay community and take control of your digital spending.',
		cta_buttons: 'Get Started',
	},
	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
